"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateQueryInfo = exports.calculateDataRequirements = exports.calculateLibraryDataRequirements = exports.calculateGapsInCare = exports.calculateRaw = exports.calculateAggregateMeasureReport = exports.calculateIndividualMeasureReports = exports.calculateMeasureReports = exports.calculate = void 0;
const Enums_1 = require("../types/Enums");
const Execution = __importStar(require("../execution/Execution"));
const CalculatorHelpers = __importStar(require("./DetailedResultsBuilder"));
const MeasureBundleHelpers = __importStar(require("../helpers/MeasureBundleHelpers"));
const ResultsHelpers = __importStar(require("./ClauseResultsBuilder"));
const DataRequirementHelpers = __importStar(require("../helpers/DataRequirementHelpers"));
const MeasureReportBuilder_1 = __importDefault(require("./MeasureReportBuilder"));
const GapsReportBuilder = __importStar(require("./GapsReportBuilder"));
const HTMLBuilder_1 = require("./HTMLBuilder");
const QueryFilterParser_1 = require("../helpers/elm/QueryFilterParser");
const RetrievesHelper = __importStar(require("../helpers/elm/RetrievesHelper"));
const CustomErrors_1 = require("../types/errors/CustomErrors");
const cql_execution_1 = require("cql-execution");
const cql_exec_fhir_1 = require("cql-exec-fhir");
const DetailedResultsHelpers_1 = require("../helpers/DetailedResultsHelpers");
const ELMInfoCache_1 = require("../helpers/elm/ELMInfoCache");
const lodash_1 = __importStar(require("lodash"));
const ReportBuilderFactory_1 = require("../helpers/ReportBuilderFactory");
/**
 * Calculate measure against a set of patients. Returning detailed results for each patient and population group.
 *
 * @param measureBundle Bundle with a Measure Resource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns Detailed execution results. One for each patient.
 */
async function calculate(measureBundle, patientBundles, options, valueSetCache = []) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    // Ensure verboseCalculationResults defaults to true when not provided in options
    options.verboseCalculationResults = (_a = options.verboseCalculationResults) !== null && _a !== void 0 ? _a : true;
    const debugObject = options.enableDebugOutput ? {} : undefined;
    if (options.clearElmJsonsCache) {
        (0, ELMInfoCache_1.clearElmInfoCache)();
    }
    // Ensure the CalculationOptions have sane defaults, only if they're not set
    options.calculateHTML = (_b = options.calculateHTML) !== null && _b !== void 0 ? _b : true;
    options.calculateSDEs = (_c = options.calculateSDEs) !== null && _c !== void 0 ? _c : true;
    options.calculateRAVs = (_d = options.calculateRAVs) !== null && _d !== void 0 ? _d : true;
    options.calculateClauseCoverage = (_e = options.calculateClauseCoverage) !== null && _e !== void 0 ? _e : true;
    options.calculateClauseUncoverage = (_f = options.calculateClauseUncoverage) !== null && _f !== void 0 ? _f : false;
    options.calculateCoverageDetails = (_g = options.calculateCoverageDetails) !== null && _g !== void 0 ? _g : false;
    options.disableHTMLOrdering = (_h = options.disableHTMLOrdering) !== null && _h !== void 0 ? _h : false;
    options.buildStatementLevelHTML = (_j = options.buildStatementLevelHTML) !== null && _j !== void 0 ? _j : false;
    const compositeMeasureResource = MeasureBundleHelpers.extractCompositeMeasure(measureBundle);
    const isCompositeExecution = compositeMeasureResource != null;
    const measuresToExecute = isCompositeExecution
        ? MeasureBundleHelpers.extractComponentsFromMeasure(compositeMeasureResource, measureBundle)
        : [MeasureBundleHelpers.extractMeasureFromBundle(measureBundle)];
    // Get the PatientSource to use for calculation.
    let patientSource = resolvePatientSource(patientBundles, options);
    const executionResults = [];
    let overallClauseCoverageHTML;
    let groupClauseCoverageHTML;
    let groupClauseUncoverageHTML;
    let groupClauseCoverageDetails;
    let newValueSetCache = [...valueSetCache];
    const allELM = [];
    let mainLibraryName = '';
    for (const measure of measuresToExecute) {
        // Get the default measurement period out of the Measure object
        const measurementPeriod = MeasureBundleHelpers.extractMeasurementPeriod(measure);
        // Set the measurement period start/end, but only if the caller didn't specify one
        options.measurementPeriodStart = (_k = options.measurementPeriodStart) !== null && _k !== void 0 ? _k : measurementPeriod.measurementPeriodStart;
        options.measurementPeriodEnd = (_l = options.measurementPeriodEnd) !== null && _l !== void 0 ? _l : measurementPeriod.measurementPeriodEnd;
        const results = await Execution.execute(measure, measureBundle, patientSource, options, newValueSetCache, debugObject);
        if (!results.rawResults) {
            throw new Error((_m = results.errorMessage) !== null && _m !== void 0 ? _m : 'something happened with no error message');
        }
        const rawResults = results.rawResults;
        if (!results.elmLibraries || !results.mainLibraryName) {
            throw new CustomErrors_1.UnexpectedResource('no libraries were found');
        }
        if (options.useValueSetCaching && results.valueSetCache) {
            newValueSetCache = newValueSetCache.concat(results.valueSetCache);
        }
        const executedELM = results.elmLibraries;
        if (options.returnELM) {
            allELM.push(...executedELM);
        }
        mainLibraryName = results.mainLibraryName;
        // Grab all patient IDs from the raw results.
        const patientIds = Object.keys(rawResults.patientResults);
        // Iterate over patient bundles and make results for each of them.
        patientIds.forEach(patientId => {
            var _a;
            let patientExecutionResult;
            // For composite execution, we want to modify the results of a previously existing patient
            // For non-composite execution, there should never be a case where the same patientId occurs twice in this loop
            const existingResult = executionResults.find(er => er.patientId === patientId);
            if (existingResult) {
                patientExecutionResult = existingResult;
            }
            else {
                patientExecutionResult = {
                    patientId: patientId,
                    detailedResults: [],
                    evaluatedResource: rawResults.patientEvaluatedRecords[patientId],
                    patientObject: rawResults.patientResults[patientId]['Patient']
                };
                executionResults.push(patientExecutionResult);
            }
            // Grab statement results for the patient
            const patientStatementResults = rawResults.patientResults[patientId];
            // Grab localId results for the patient
            const patientLocalIdResults = rawResults.localIdPatientResultsMap[patientId];
            // iterator to use for group ID if they are defined in the population groups
            let i = 1;
            // use scoring code from measure as a fallback when building population group
            // relevance map (if scoring code is not present at the group level)
            const measureScoringCode = MeasureBundleHelpers.getScoringCodeFromMeasure(measure);
            // Iterate over measure population groups
            (_a = measure.group) === null || _a === void 0 ? void 0 : _a.forEach(group => {
                var _a, _b, _c, _d, _e;
                // build initial results set with population values
                const detailedGroupResult = CalculatorHelpers.createPopulationValues(measure, group, patientStatementResults);
                if (isCompositeExecution) {
                    detailedGroupResult.componentCanonical = `${measure.url}${measure.version ? `|${measure.version}` : ''}`;
                }
                // fix groupId to an auto incremented if it was not found.
                if (detailedGroupResult.groupId === 'unknown') {
                    detailedGroupResult.groupId = `population-group-${i++}`;
                }
                // get the relevance information for each population
                detailedGroupResult.populationRelevance = ResultsHelpers.buildPopulationGroupRelevanceMap(detailedGroupResult, group, measureScoringCode);
                // use relevance info to fill out statement relevance information and create initial statementResults structure
                detailedGroupResult.statementResults = ResultsHelpers.buildStatementRelevanceMap(measure, detailedGroupResult.populationRelevance, mainLibraryName, executedELM, group, (_a = options.calculateSDEs) !== null && _a !== void 0 ? _a : false, (_b = options.calculateRAVs) !== null && _b !== void 0 ? _b : false);
                // adds result information to the statement results and builds up clause results
                detailedGroupResult.clauseResults = ResultsHelpers.buildStatementAndClauseResults(measure, executedELM, patientLocalIdResults, detailedGroupResult.statementResults, true, true);
                if (options.calculateHTML) {
                    const html = (0, HTMLBuilder_1.generateHTML)(measure, executedELM, detailedGroupResult.statementResults, detailedGroupResult.clauseResults, detailedGroupResult.groupId, options);
                    detailedGroupResult.html = html;
                    if (debugObject && options.enableDebugOutput) {
                        const debugHtml = {
                            name: `clauses-${detailedGroupResult.groupId}.html`,
                            html
                        };
                        if (Array.isArray(debugObject.html) && ((_c = debugObject.html) === null || _c === void 0 ? void 0 : _c.length) !== 0) {
                            (_d = debugObject.html) === null || _d === void 0 ? void 0 : _d.push(debugHtml);
                        }
                        else {
                            debugObject.html = [debugHtml];
                        }
                    }
                }
                // add this group result to the patient results
                (_e = patientExecutionResult.detailedResults) === null || _e === void 0 ? void 0 : _e.push(detailedGroupResult);
                if (isCompositeExecution) {
                    if (!patientExecutionResult.componentResults) {
                        patientExecutionResult.componentResults = [];
                    }
                    patientExecutionResult.componentResults.push({
                        groupId: detailedGroupResult.groupId,
                        componentCanonical: detailedGroupResult.componentCanonical,
                        populationResults: detailedGroupResult.populationResults
                    });
                }
            });
            if (options.calculateSDEs || options.calculateRAVs) {
                const sdeValues = ResultsHelpers.getSDEValues(measure, patientStatementResults);
                // put raw SDE values onto execution result
                if (options.calculateSDEs) {
                    patientExecutionResult.supplementalData = sdeValues.filter(sd => sd.usage === 'supplemental-data');
                }
                // put raw RAV values onto execution result
                if (options.calculateRAVs) {
                    patientExecutionResult.riskAdjustment = sdeValues.filter(sd => sd.usage === 'risk-adjustment-factor');
                }
            }
        });
        patientSource = resolvePatientSource(patientBundles, options);
        if (!isCompositeExecution && options.calculateClauseCoverage) {
            const coverage = (0, HTMLBuilder_1.generateClauseCoverageHTML)(measure, executedELM, executionResults, options);
            groupClauseCoverageHTML = coverage.coverage;
            overallClauseCoverageHTML = '';
            Object.entries(groupClauseCoverageHTML).forEach(([groupId, result]) => {
                overallClauseCoverageHTML += result;
                if (debugObject && options.enableDebugOutput) {
                    const debugHTML = {
                        name: `clause-coverage-${groupId}.html`,
                        html: result
                    };
                    if (Array.isArray(debugObject.html)) {
                        debugObject.html.push(debugHTML);
                    }
                    else {
                        debugObject.html = [debugHTML];
                    }
                }
            });
            // pull out uncoverage html
            if (options.calculateClauseUncoverage && coverage.uncoverage) {
                groupClauseUncoverageHTML = coverage.uncoverage;
                if (debugObject && options.enableDebugOutput) {
                    Object.entries(groupClauseUncoverageHTML).forEach(([groupId, result]) => {
                        const debugUncoverageHTML = {
                            name: `clause-uncoverage-${groupId}.html`,
                            html: result
                        };
                        if (Array.isArray(debugObject.html)) {
                            debugObject.html.push(debugUncoverageHTML);
                        }
                        else {
                            debugObject.html = [debugUncoverageHTML];
                        }
                    });
                }
            }
            // don't necessarily need this file, but adding it for backwards compatibility
            if (debugObject && options.enableDebugOutput) {
                (_o = debugObject.html) === null || _o === void 0 ? void 0 : _o.push({
                    name: 'overall-clause-coverage.html',
                    html: overallClauseCoverageHTML
                });
            }
            // grab coverage details
            if (options.calculateCoverageDetails && coverage.details) {
                groupClauseCoverageDetails = coverage.details;
                if (debugObject && options.enableDebugOutput) {
                    debugObject.coverageDetails = groupClauseCoverageDetails;
                }
            }
        }
    }
    if (debugObject && options.enableDebugOutput) {
        debugObject.detailedResults = executionResults;
    }
    let prunedExecutionResults;
    if (options.verboseCalculationResults === false) {
        // Prune to simple view
        prunedExecutionResults = (0, DetailedResultsHelpers_1.pruneDetailedResults)(executionResults);
    }
    else {
        prunedExecutionResults = executionResults;
    }
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ results: prunedExecutionResults, debugOutput: debugObject }, (options.returnELM && {
        elmLibraries: lodash_1.default.uniqWith(allELM, (libOne, libTwo) => libOne.library.identifier.id === libTwo.library.identifier.id &&
            libOne.library.identifier.version === libOne.library.identifier.version),
        mainLibraryName
    })), (options.useValueSetCaching &&
        newValueSetCache && {
        valueSetCache: lodash_1.default.uniqWith(newValueSetCache, (vsOne, vsTwo) => vsOne.url === vsTwo.url && vsOne.version === vsTwo.version)
    })), (overallClauseCoverageHTML && { coverageHTML: overallClauseCoverageHTML })), (groupClauseCoverageHTML && { groupClauseCoverageHTML: groupClauseCoverageHTML })), (groupClauseUncoverageHTML && { groupClauseUncoverageHTML: groupClauseUncoverageHTML })), (groupClauseCoverageDetails && { groupClauseCoverageDetails: groupClauseCoverageDetails }));
}
exports.calculate = calculate;
/**
 * Calculate measure against a set of patients. Returning individual or summary MeasureReports based on options
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns MeasureReport resource(s) for each patient or entire population according to standard https://www.hl7.org/fhir/measurereport.html
 */
async function calculateMeasureReports(measureBundle, patientBundles, options, valueSetCache = []) {
    return options.reportType === 'summary'
        ? calculateAggregateMeasureReport(measureBundle, patientBundles, options, valueSetCache)
        : calculateIndividualMeasureReports(measureBundle, patientBundles, options, valueSetCache);
}
exports.calculateMeasureReports = calculateMeasureReports;
/**
 * Calculate measure against a set of patients. Returning measure reports for each patient.
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns MeasureReport resource for each patient according to standard https://www.hl7.org/fhir/measurereport.html
 */
async function calculateIndividualMeasureReports(measureBundle, patientBundles, options, valueSetCache = []) {
    if (options.reportType && options.reportType !== 'individual') {
        throw new CustomErrors_1.UnsupportedProperty('calculateMeasureReports only supports reportType "individual".');
    }
    const compositeMeasureResource = MeasureBundleHelpers.extractCompositeMeasure(measureBundle);
    if (compositeMeasureResource) {
        throw new Error('Composite measures require reportType "summary".');
    }
    // options should be updated by this call if measurementPeriod wasn't initially passed in
    const calculationResults = await calculate(measureBundle, patientBundles, options, valueSetCache);
    const { results, debugOutput } = calculationResults;
    const reports = MeasureReportBuilder_1.default.buildMeasureReports(measureBundle, results, options);
    if (debugOutput && options.enableDebugOutput) {
        debugOutput.measureReports = reports;
    }
    return { results: reports, debugOutput, valueSetCache: calculationResults.valueSetCache };
}
exports.calculateIndividualMeasureReports = calculateIndividualMeasureReports;
/**
 * Calculate measure against a set of patients. Returning a single MeasureReport for aggregated results.
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns MeasureReport resource summary according to standard https://www.hl7.org/fhir/measurereport.html
 */
async function calculateAggregateMeasureReport(measureBundle, patientBundles, options, valueSetCache = []) {
    if (options.reportType && options.reportType === 'individual') {
        throw new Error('calculateAggregateMeasureReports only supports reportType "summary".');
    }
    // options should be updated by this call if measurementPeriod wasn't initially passed in
    const calculationResults = await calculate(measureBundle, patientBundles, options, valueSetCache);
    const { results, debugOutput } = calculationResults;
    const builder = (0, ReportBuilderFactory_1.getReportBuilder)(measureBundle, options);
    builder.addAllResults(results);
    const report = builder.getReport();
    if (debugOutput && options.enableDebugOutput) {
        debugOutput.measureReports = [report];
    }
    return { results: report, debugOutput, valueSetCache: calculationResults.valueSetCache };
}
exports.calculateAggregateMeasureReport = calculateAggregateMeasureReport;
/**
 * Get raw results from cql-execution
 *
 * @param measureBundle Bundle with a Measure Resource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns pass through of raw calculation results from the engine
 */
async function calculateRaw(measureBundle, patientBundles, options = {}, valueSetCache = []) {
    var _a;
    const debugObject = options.enableDebugOutput ? {} : undefined;
    // Get the PatientSource to use for calculation.
    const patientSource = resolvePatientSource(patientBundles, options);
    const measure = MeasureBundleHelpers.extractMeasureFromBundle(measureBundle);
    const results = await Execution.execute(measure, measureBundle, patientSource, options, valueSetCache, debugObject);
    if (results.rawResults) {
        return { results: results.rawResults, debugOutput: debugObject, valueSetCache: results.valueSetCache };
    }
    else {
        throw new CustomErrors_1.ErrorWithDebugInfo((_a = results.errorMessage) !== null && _a !== void 0 ? _a : 'something happened with no error message', debugObject);
    }
}
exports.calculateRaw = calculateRaw;
/**
 * Get any gaps in care for the patients
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns gaps bundle of DetectedIssues and GuidanceResponses
 */
async function calculateGapsInCare(measureBundle, patientBundles, options, valueSetCache = []) {
    // Detailed results for populations get ELM content back
    options.returnELM = true;
    const calculationResults = await calculate(measureBundle, patientBundles, options, valueSetCache);
    const { results, debugOutput, elmLibraries, mainLibraryName, parameters } = calculationResults;
    const measureReports = MeasureReportBuilder_1.default.buildMeasureReports(measureBundle, results, options);
    const result = [];
    const errorLog = [];
    const resultPromises = results.map(async (res) => {
        var _a;
        const matchingMeasureReport = measureReports.find(mr => { var _a, _b; return ((_b = (_a = mr.subject) === null || _a === void 0 ? void 0 : _a.reference) === null || _b === void 0 ? void 0 : _b.split('/')[1]) === res.patientId; });
        if (!matchingMeasureReport) {
            throw new Error(`No MeasureReport generated during gaps in care for ${res.patientId}`);
        }
        const drPromises = (_a = res.detailedResults) === null || _a === void 0 ? void 0 : _a.map(async (dr, i) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            const measureResource = MeasureBundleHelpers.extractMeasureFromBundle(measureBundle);
            const matchingGroup = ((_a = measureResource.group) === null || _a === void 0 ? void 0 : _a.find(g => g.id === dr.groupId)) || ((_b = measureResource.group) === null || _b === void 0 ? void 0 : _b[i]);
            // Gaps only supported for proportion/ratio measures
            const scoringCode = (_c = MeasureBundleHelpers.getScoringCodeFromGroup(matchingGroup)) !== null && _c !== void 0 ? _c : MeasureBundleHelpers.getScoringCodeFromMeasure(measureResource);
            if (scoringCode !== Enums_1.MeasureScoreType.PROP) {
                throw new CustomErrors_1.UnsupportedProperty(`Gaps in care not supported for measure scoring type ${scoringCode}`);
            }
            const denomResult = (_e = (_d = dr.populationResults) === null || _d === void 0 ? void 0 : _d.find(pr => pr.populationType === Enums_1.PopulationType.DENOM)) === null || _e === void 0 ? void 0 : _e.result;
            const numerResult = (_g = (_f = dr.populationResults) === null || _f === void 0 ? void 0 : _f.find(pr => pr.populationType === Enums_1.PopulationType.NUMER)) === null || _g === void 0 ? void 0 : _g.result;
            const numerRelevance = (_j = (_h = dr.populationRelevance) === null || _h === void 0 ? void 0 : _h.find(pr => pr.populationType === Enums_1.PopulationType.NUMER)) === null || _j === void 0 ? void 0 : _j.result;
            const improvementNotation = (_k = MeasureBundleHelpers.getImprovementNotationFromGroup(matchingGroup)) !== null && _k !== void 0 ? _k : (_m = (_l = measureResource.improvementNotation) === null || _l === void 0 ? void 0 : _l.coding) === null || _m === void 0 ? void 0 : _m[0].code;
            if (!improvementNotation) {
                throw new CustomErrors_1.UnexpectedProperty('Unable to find improvement notation code for this group or measure');
            }
            // If positive improvement measure, consider patients in denominator but not numerator for gaps
            // If negative improvement measure, consider patients in numerator for gaps
            // For either case, ignore patient if numerator isn't relevant
            const populationCriteria = numerRelevance &&
                (improvementNotation === Enums_1.ImprovementNotation.POSITIVE ? denomResult && !numerResult : numerResult);
            if (populationCriteria) {
                if (!matchingGroup) {
                    throw new Error(`Could not find group with id ${dr.groupId} in measure resource`);
                }
                const numerCriteria = (_o = matchingGroup.population) === null || _o === void 0 ? void 0 : _o.find(pop => { var _a; return ((_a = pop.code) === null || _a === void 0 ? void 0 : _a.coding) && pop.code.coding[0].code === Enums_1.PopulationType.NUMER; });
                if (!numerCriteria) {
                    throw new CustomErrors_1.UnexpectedProperty(`Could not find numerator criteria expression in measure group ${dr.groupId}`);
                }
                const numerExpressionName = numerCriteria.criteria.expression;
                const mainLibraryELM = elmLibraries === null || elmLibraries === void 0 ? void 0 : elmLibraries.find(lib => lib.library.identifier.id === mainLibraryName);
                if (!mainLibraryELM || !elmLibraries) {
                    throw new CustomErrors_1.UnexpectedResource(`Could not find ELM for ${mainLibraryName}`);
                }
                const numerELMExpression = mainLibraryELM.library.statements.def.find(e => e.name === numerExpressionName);
                if (!numerELMExpression) {
                    throw new CustomErrors_1.UnexpectedProperty(`Expression ${numerExpressionName} not found in ${mainLibraryName}`);
                }
                // Parse ELM for basic info about queries
                const retrievesOutput = RetrievesHelper.findRetrieves(mainLibraryELM, elmLibraries, numerELMExpression.expression);
                const baseRetrieves = retrievesOutput.results;
                const retrievesErrors = retrievesOutput.withErrors;
                errorLog.push(...retrievesErrors);
                // Add detailed info to queries based on clause results
                const gapsRetrieves = GapsReportBuilder.processQueriesForGaps(baseRetrieves, dr);
                const grPromises = gapsRetrieves.map(async (retrieve) => {
                    // If the retrieves have a localId for the query and a known library name, we can get more info
                    // on how the query filters the sources.
                    if (retrieve.queryLocalId && retrieve.queryLibraryName) {
                        const library = elmLibraries.find(lib => lib.library.identifier.id === retrieve.queryLibraryName);
                        if (library) {
                            retrieve.queryInfo = await (0, QueryFilterParser_1.parseQueryInfo)(library, elmLibraries, retrieve.queryLocalId, retrieve.valueComparisonLocalId, parameters, res.patientObject);
                        }
                    }
                });
                await Promise.all(grPromises);
                const { results: detailedGapsRetrieves, withErrors: reasonDetailErrors } = GapsReportBuilder.calculateReasonDetail(gapsRetrieves, improvementNotation, dr);
                errorLog.push(...reasonDetailErrors);
                const { detectedIssues, withErrors: detectedIssueErrors } = GapsReportBuilder.generateDetectedIssueResources(detailedGapsRetrieves, matchingMeasureReport, improvementNotation);
                errorLog.push(...detectedIssueErrors);
                const patient = (_p = res.patientObject) === null || _p === void 0 ? void 0 : _p._json;
                const gapsBundle = GapsReportBuilder.generateGapsInCareBundle(detectedIssues, matchingMeasureReport, patient);
                result.push(gapsBundle);
                if (debugOutput && options.enableDebugOutput) {
                    debugOutput.gaps = {
                        retrieves: detailedGapsRetrieves,
                        bundle: result
                    };
                }
            }
            else {
                result.push({});
            }
        });
        if (drPromises) {
            await Promise.all(drPromises);
        }
    });
    await Promise.all(resultPromises);
    return {
        results: (result.length === 1 ? result[0] : result),
        debugOutput,
        valueSetCache: calculationResults.valueSetCache,
        withErrors: errorLog
    };
}
exports.calculateGapsInCare = calculateGapsInCare;
/**
 * Get data requirements for a Library bundle
 *
 * @param libraryBundle Bundle of library resources
 * @param options Options for calculation.
 *
 * @returns FHIR Library of data requirements
 */
async function calculateLibraryDataRequirements(libraryBundle, options = {}) {
    // omit measurementPeriodStart/measurementPeriodEnd since there is no measure
    options = (0, lodash_1.omit)(options, 'measurementPeriodStart', 'measurementPeriodEnd');
    if (options.rootLibRef === undefined) {
        throw new CustomErrors_1.UnexpectedProperty('Root lib ref must be provided in order to calculate library dataRequirements');
    }
    // Extract the library ELM, and the id of the root library, from the library bundle
    const { cqls, rootLibIdentifier, elmJSONs } = MeasureBundleHelpers.extractLibrariesFromLibraryBundle(libraryBundle, options.rootLibRef);
    const dataRequirements = await DataRequirementHelpers.getDataRequirements(cqls, rootLibIdentifier, elmJSONs, options);
    dataRequirements.results.relatedArtifact = DataRequirementHelpers.getFlattenedRelatedArtifacts(libraryBundle, options.rootLibRef);
    return dataRequirements;
}
exports.calculateLibraryDataRequirements = calculateLibraryDataRequirements;
/**
 * Get data requirements for this measure
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param options Options for calculation.
 *
 * @returns FHIR Library of data requirements
 */
async function calculateDataRequirements(measureBundle, options = {}) {
    // Extract the library ELM, and the id of the root library, from the measure bundle
    const measure = MeasureBundleHelpers.extractMeasureFromBundle(measureBundle);
    const effectivePeriod = measure.effectivePeriod;
    const { cqls, rootLibIdentifier, elmJSONs } = MeasureBundleHelpers.extractLibrariesFromMeasureBundle(measureBundle, measure);
    const dataRequirements = await DataRequirementHelpers.getDataRequirements(cqls, rootLibIdentifier, elmJSONs, options, effectivePeriod);
    dataRequirements.results.relatedArtifact = DataRequirementHelpers.getFlattenedRelatedArtifacts(measureBundle);
    return dataRequirements;
}
exports.calculateDataRequirements = calculateDataRequirements;
/**
 * Get detailed query info for all statements of a Measure
 *
 * @param measureBundle Bundle with a Measure resource and all dependent library resources
 * @returns Detailed query info object for all statements
 */
async function calculateQueryInfo(measureBundle, options = {}) {
    // Extract the library ELM, and the id of the root library, from the measure bundle
    const { cqls, rootLibIdentifier, elmJSONs } = MeasureBundleHelpers.extractLibrariesFromMeasureBundle(measureBundle);
    const rootLib = elmJSONs.find(ej => ej.library.identifier == rootLibIdentifier);
    const { startCql, endCql } = Execution.getCQLIntervalEndpoints(options);
    if (!(rootLib === null || rootLib === void 0 ? void 0 : rootLib.library)) {
        throw new CustomErrors_1.UnexpectedResource("root library doesn't contain a library object"); //unexpected resource
    }
    const parameters = { 'Measurement Period': new cql_execution_1.Interval(startCql, endCql) };
    // get the retrieves for every statement in the root library
    const withErrors = [];
    let statements = rootLib.library.statements.def;
    if (options.focusedStatement) {
        const focalStatement = statements.find(s => s.name === options.focusedStatement);
        // if focal statement isn't found, warn and stick with the default
        if (focalStatement) {
            statements = [focalStatement];
        }
        else {
            console.warn(`Focused statement \"${options.focusedStatement}\" not found in root library.`);
        }
    }
    const allRetrieves = statements.flatMap(statement => {
        if (statement.expression && statement.name != 'Patient') {
            const retrievesOutput = RetrievesHelper.findRetrieves(rootLib, elmJSONs, statement.expression);
            withErrors.push(...retrievesOutput.withErrors);
            return retrievesOutput.results;
        }
        else {
            return [];
        }
    });
    const allRetrievesPromises = allRetrieves.map(async (retrieve) => {
        // If the retrieves have a localId for the query and a known library name, we can get more info
        // on how the query filters the sources.
        if (retrieve.queryLocalId && retrieve.queryLibraryName) {
            const library = elmJSONs.find(lib => lib.library.identifier.id === retrieve.queryLibraryName);
            if (library) {
                retrieve.queryInfo = await (0, QueryFilterParser_1.parseQueryInfo)(library, elmJSONs, retrieve.queryLocalId, retrieve.valueComparisonLocalId, parameters);
            }
        }
    });
    await Promise.all(allRetrievesPromises);
    return {
        results: allRetrieves,
        debugOutput: {
            cql: cqls,
            elm: elmJSONs
        },
        withErrors
    };
}
exports.calculateQueryInfo = calculateQueryInfo;
/**
 * Resolve the PatientSource to use for calculation. If a PatientSource was provided, use it. Otherwise use
 * cql-exec-fhir to make one from Patient Bundles.
 *
 * @param patientBundles Patient bundle array passed in.
 * @param options Options passed into the calculator.
 * @returns PatientSource to use for calculation.
 */
function resolvePatientSource(patientBundles, options) {
    var _a;
    if (options.patientSource) {
        return options.patientSource;
    }
    else {
        //if there are entries, pb.entry?.length will be > 0 which is truthy. Otherwise falsy
        if (patientBundles.filter(pb => { var _a; return (_a = pb.entry) === null || _a === void 0 ? void 0 : _a.length; }).length === 0) {
            throw new CustomErrors_1.UnexpectedResource('No entries found in passed patient bundles');
        }
        const patientSource = cql_exec_fhir_1.PatientSource.FHIRv401({ requireProfileTagging: (_a = options.trustMetaProfile) !== null && _a !== void 0 ? _a : true });
        patientSource.loadBundles(patientBundles);
        return patientSource;
    }
}
//# sourceMappingURL=Calculator.js.map